import { render, staticRenderFns } from "./OrgAdminSideNavLayout.vue?vue&type=template&id=715d865b&"
import script from "./OrgAdminSideNavLayout.vue?vue&type=script&lang=ts&"
export * from "./OrgAdminSideNavLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports